import { defineNuxtRouteMiddleware } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

export default defineNuxtRouteMiddleware(async () => {
  const { isUserAuthenticatedSeller } = useUserStore()
  const sellerInfoStore = useSellerInfoStore()

  if (isUserAuthenticatedSeller.value && !sellerInfoStore.hasFetchSellerInfo) {
    await sellerInfoStore.fetchSellerInfo()
  }
})
